import JSZip from 'jszip';
var CONTENT_TYPES_XML = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>\n<Types xmlns=\"http://schemas.openxmlformats.org/package/2006/content-types\">\n  <Default Extension=\"rels\" ContentType=\"application/vnd.openxmlformats-package.relationships+xml\"/>\n  <Default Extension=\"xml\" ContentType=\"application/xml\"/>\n  <Override PartName=\"/word/document.xml\" ContentType=\"application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml\"/>\n</Types>";
var RELS_XML = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>\n<Relationships xmlns=\"http://schemas.openxmlformats.org/package/2006/relationships\">\n  <Relationship Id=\"rId1\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument\" Target=\"word/document.xml\"/>\n</Relationships>";
var escapeXml = function escapeXml() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');
};
var buildParagraphXml = function buildParagraphXml(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    _ref$bold = _ref.bold,
    bold = _ref$bold === void 0 ? false : _ref$bold;
  var runProperties = bold ? '<w:rPr><w:b/></w:rPr>' : '';
  var lines = String(text).split('\n');
  var runs = lines.map(function (line, index) {
    return "<w:r>".concat(runProperties, "<w:t xml:space=\"preserve\">").concat(escapeXml(line), "</w:t></w:r>").concat(index < lines.length - 1 ? '<w:br/>' : '');
  }).join('');
  return "<w:p>".concat(runs, "</w:p>");
};
var buildDocumentXml = function buildDocumentXml(paragraphs) {
  var body = paragraphs.map(buildParagraphXml).join('');
  return "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>\n<w:document xmlns:w=\"http://schemas.openxmlformats.org/wordprocessingml/2006/main\">\n  <w:body>".concat(body, "<w:sectPr/></w:body>\n</w:document>");
};

// Hand-rolled minimal OOXML package: Word doesn't require docProps/styles parts to open a
// document, just content types + package rels + the document part itself.
export var buildDocxBlob = function buildDocxBlob(paragraphs) {
  var zip = new JSZip();
  zip.file('[Content_Types].xml', CONTENT_TYPES_XML);
  zip.folder('_rels').file('.rels', RELS_XML);
  zip.folder('word').file('document.xml', buildDocumentXml(paragraphs));
  return zip.generateAsync({
    type: 'blob',
    mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  });
};
export default buildDocxBlob;